import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import { selectClasses } from './styles.js';
import { useUiV2 } from './v2.js';
/**
 * 素のセレクト primitive。Input と同一の枠線/フォーカス/disabled スタイルを共有する。
 * option は children で渡す。ラベルが要る場合は呼び出し側で付与する。
 */
export const Select = forwardRef(function Select({ invalid, size, fullWidth, v2, surface, className, children, ...rest }, ref) {
    const isV2 = useUiV2(v2);
    return (_jsx("select", { ref: ref, className: selectClasses({ invalid, size, fullWidth, v2: isV2, surface, className }), ...rest, children: children }));
});
//# sourceMappingURL=Select.js.map